import React from 'react';

// Inline SVG rather than raster or an icon font: the strokes are
// `currentColor`, so one asset serves Kit Keeper, Keepr and St Anne's
// (an external SVG is an isolated document and cannot inherit page colour).
// Same reasoning as `TileIcons.tsx` — DESIGN_LANGUAGE.md Phase 4.4 item 5.

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
  focusable: 'false' as const,
};

/** Stacked boxes — the "pick a ready-made package" accelerator. */
export function PackagesIcon(): JSX.Element {
  return (
    <svg {...base} width="16" height="16">
      <path d="M3 8.5 12 4l9 4.5-9 4.5-9-4.5Z" />
      <path d="m3 13 9 4.5L21 13" />
      <path d="m3 17.5 9 4.5 9-4.5" />
    </svg>
  );
}

/** Question mark in a circle — help, not an action. */
export function HelpIcon(): JSX.Element {
  return (
    <svg {...base} width="16" height="16">
      <circle cx="12" cy="12" r="9" />
      <path d="M9.6 9.4a2.5 2.5 0 0 1 4.9.6c0 1.7-2.5 2.5-2.5 2.5" />
      <path d="M12 17h.01" />
    </svg>
  );
}
